/** @jsx jsx */
import { jsx, useThemeUI } from "theme-ui"
import { useState, useRef, useEffect, useContext } from "react"
import PropTypes from "prop-types"

import ShopContext from "../context/shop-context"
import { ab } from "../theme"
import Input from "./form/input"

const Confirmation = ({ hash, heading, subHeading, buttonText }) => {
  const shop = useContext(ShopContext)

  const [message, setMessage] = useState("")
  const [hasHash, setHasHash] = useState(false)
  const [animate, setAnimate] = useState(true)
  const [error, setError] = useState(false)

  const refForm = useRef()
  const { rawColors: colors } = useThemeUI().theme

  useEffect(() => {
    if (hash) {
      setError(true)
      setMessage("Please Insert Password")
      setAnimate(true)
      setHasHash(true)
    } else {
      setMessage("No Token")
      setAnimate(true)
    }
    setAnimate(false)
  }, [hash])

  const handleSubmit = (evt) => {
    evt.preventDefault()
    let form = refForm.current.elements
    let { password } = form
    shop.handleInvitation(hash, password.value, function (err, msg) {
      setMessage(msg)
      setError(err)
      setAnimate(true)
      console.log("err", err)
      if (err) {
        setTimeout(() => {
          window.location.href = "/gba-shop/login"
        }, 3000)
      }
    })
    setAnimate(false)
  }
  return (
    <div
      className="confirmation"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "90vh",
        position: "relative",
        pt: "25%",
        justifyContent: "space-between",
        bg: ab({ _: colors.modes["group"].primary, md: "transparent" }),
      }}
    >
      <div
        sx={{
          bg: ab({ _: "", md: colors.modes["group"].primary }),
          width: ab({ _: "100%", md: "550px" }),
          px: 4,
          py: 5,
          alignSelf: "center",
        }}
      >
        <h6
          sx={{
            m: 0,
            p: 0,
            fontSize: "14px",
            letterSpacing: 2,
            fontWeight: 1,
            textTransform: "uppercase",
            color: "background",
          }}
        >
          {subHeading}
        </h6>
        <h2
          sx={{
            fontSize: 4,
            my: 1,
            color: "background",
          }}
        >
          {heading}
        </h2>
        <div
          sx={{
            color: "background",
            textAlign: "center",
            padding: 2,
            mt: 3,
            display: message ? "block" : "none",
            variant: message
              ? error
                ? "styles.success"
                : "styles.failed"
              : "",
            animationName: animate ? "swing" : "",
            animationDuration: "600ms",
          }}
        >
          {message}
        </div>
        <form
          name="setPassword"
          ref={refForm}
          onSubmit={handleSubmit}
          sx={{
            pt: 3,
            "&>div": {
              pb: 3,
            },
          }}
        >
          <div>
            <Input
              type="password"
              placeholder="password"
              required={true}
              name="password"
              label=""
              disabled={hasHash ? false : true}
            />
          </div>

          <div
            sx={{
              pt: 3,
            }}
          >
            <button
              type="submit"
              disabled={hasHash ? false : true}
              sx={{
                variant: "styles.ghostButton",
                color: "#fff",
                border: "solid 1px #fff",
                py: 2,
                px: 4,
                "&:hover": {
                  bg: "#fff",
                  color: colors.modes["group"].primary,
                },
              }}
            >
              {buttonText}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

Confirmation.propTypes = {
  hash: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
}

export default Confirmation
